import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q8ypma3xp2: FaireBrandEntity = {
  token: "b_q8ypma3xp2",
  type: "brand",
  name: "Superior Stones & Gifts INTL LLP",
  avatarUrl:
    "https://cdn.faire.com/fastly/37552f137c58c018da688b7593e4cacdb6e8a4e44c4436d634dca9022ac01858.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e2880863b7245a5964e87c527c303292c6ba472344662c28a2d908f05b4f9f25.png",
  logoUrl:
    "https://cdn.faire.com/fastly/37552f137c58c018da688b7593e4cacdb6e8a4e44c4436d634dca9022ac01858.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e2880863b7245a5964e87c527c303292c6ba472344662c28a2d908f05b4f9f25.png",
  location: "Burien, WA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 17,
  isTopShop: true,
  isInsider: true,
  description:
    "Superior Stones & Gifts is just what is sounds like. We are meticulous about quality. All our products are curated with the end use in mind. Is it beautiful, is it a quality product, does it have good value for the price and will our customers be happy with it. If the answers are yes, then we will stock it for our retailers knowing they will be successful with our products.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:49.760Z",
    importedBy: "entity-db-cli",
  },
};
